import React, { useState, useEffect } from "react";
import TopNavigation from "../../layouts/top-navigation/TopNavigation";
import InterviewSideBar from "../../components/InterviewSideBar";
import InterviewHistory from "./InterviewHistory";
import ActiveInterview from "./ActiveInterview";
import BottomNavigation from "../../layouts/bottom-navigation/BottomNavigation";



const Interviews = () => {
	const [active, setActive] = useState<string>("/activeinterview");



	useEffect(() => {
		setActive("/activeinterview");
	}, []);

	return (
		<div id="screen-wrapper">
			<TopNavigation />
			<InterviewSideBar setActive={setActive} />
			<BottomNavigation />
			<main>
				<div>
					{active === "/activeinterview" && <ActiveInterview />}
					{active === "/interviewhistory" && <InterviewHistory />}
				</div>
			</main>
		</div>
	);
};

export default Interviews;
